import React from 'react';
import { withTranslation } from 'react-i18next';
import UnitForm from '../UnitForm';

class NewUnitPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      units: '',
      scale: '',
      offset: '',
      description: '',
      focus: '',
      focusError: false,
    };
  }
  onCreateUnit = (values) => {
    const { units, scale, offset, description } = values;
    this.props.onCreateUnit({ units, scale, offset, description });
  };
  render() {
    return (
      <UnitForm
        isCreate
        initialValues={this.state}
        onSubmit={(values) => this.onCreateUnit(values)}
        {...this.props}
      />
    );
  }
}
export default withTranslation('app')(NewUnitPage);
